import React from 'react';
import { useTranslation } from 'react-i18next';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { saveLanguage } from '../../utils/storage';

const AuthFloatingControls = () => {
  const { toggleTheme, isDark } = useTheme();
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLanguage);
    saveLanguage(newLanguage);
  };

  return (
    <>
      <button
        onClick={toggleTheme}
        className="fixed bottom-6 right-6 z-50 glass-button p-3 rounded-full"
        aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      >
        {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
      </button>

      <button
        onClick={toggleLanguage}
        className="fixed bottom-20 right-6 z-50 glass-button p-3 rounded-full"
        aria-label={`Switch to ${i18n.language === 'en' ? 'Arabic' : 'English'}`}
      >
        <span className="text-sm font-medium">
          {i18n.language === 'en' ? 'AR' : 'EN'}
        </span>
      </button>
    </>
  );
};

export default AuthFloatingControls;
